import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {}, //用户信息--全部的
    userType: 0,
    siteType: 'image',
    IP: '', //全局footer组件IP，在APP.vue中获取保存到vuex
    isCreatePage: false,
    searchObjetcArr: [],
    setSearchFields: [],
    showQuickSearch: false, //是否展示快速搜索框
    searchKey: '', //快速检索框的值
  },
  mutations: {
    isCreatePage(state, isCreatePage) {
      state.isCreatePage = isCreatePage
    },
    getIP(state, IP) {
      state.IP = IP
    },
    Getuserinfo(state, info) {
      state.userInfo = info
    },
    setUserInfo(state, payload) {
      state.userInfo = { ...payload }
      state.userType = payload.userType
      sessionStorage.setItem('userInfo', JSON.stringify(payload) || '{}')
      sessionStorage.setItem('userType', payload.userType)
    },
    setSearchObjects(state, payload) {
      state.searchObjetcArr = [...payload]
    },
    setSearchFields(state, searchFields) {
      state.searchFields = searchFields
    },
    setShowQuickSearch(state, payload) {
      state.showQuickSearch = payload
    },
    setSearchKey(state, payload) {
      state.searchKey = payload
    },
  },
  actions: {},
  modules: {},
})
